import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ConfirmationService } from 'primeng/api';
import { ActionService } from 'src/app/services/actions/action.service';
import { AlertService, MessageSeverity } from 'src/app/services/alert.service';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';
import { DeleteTemplateManagerRequest, DeleteTemplateManagerResponse, GetTemplateManagerRequest, GetTemplateManagerResponse, SaveTemplateManagerRequest, SaveTemplateManagerResponse } from 'src/app/services/document-type/document-type-plugin-models';
import { DocumentTypeTemplateManager } from 'src/app/services/document-type/document-type.model';
import { DocumentTypeBaseComponent } from '../../document-types-base.component';

@Component({
    selector: 'app-template-mgr',
    templateUrl: './template-mgr.component.html',
    styleUrls: ['./template-mgr.component.scss']
})
export class TemplateMgrComponent extends DocumentTypeBaseComponent implements OnChanges {
    constructor(
        private alertService: AlertService,
        private confirmationService: ConfirmationService,
        public actionService: ActionService,
        public configurationService: ConfigurationService


    ) {
        super(configurationService, actionService);
    }

    templateManager: DocumentTypeTemplateManager = new DocumentTypeTemplateManager();

    initialTemplateMgrConfig: DocumentTypeTemplateManager;

    @Input() documentTypeId: number;
    @Input() active: boolean = false;

    @ViewChild('templateManagerForm', { static: false }) templateManagerForm: NgForm;

    async ngOnChanges(changes: SimpleChanges) {
        if (changes.documentTypeId?.currentValue) {
            this.templateManager = await this.getTemplateManagerConfig(+changes.documentTypeId?.currentValue);
            this.setInitialTemplateManager();
        }
    }

    async saveChanges(event) {
        try {
            const saveResponse = await this.saveTemplateManagerConfig(this.documentTypeId, this.templateManager);

            if (saveResponse.statusCode === 200) {
                this.setInitialTemplateManager();
                this.templateManagerForm.form.markAsPristine();
                this.alertService.showMessage('Template manager settings saved.', null, MessageSeverity.success);
            } else {
                this.alertService.showMessage('Failed to save template manager settings.', 'Unknown error ocurred during the saving of template manager configuration.', MessageSeverity.error);
            }

        } catch (error) {
            this.alertService.showMessage('Failed to save template manager settings.', error.error.Message, MessageSeverity.error);
        }
    }

    resetForm() {
        this.templateManagerForm.resetForm({
            visible: this.initialTemplateMgrConfig.visible
        });
    }

    async deleteTemplateManager() {

        const msg = `Are you sure you want to delete this template manager configuration?`;

        this.confirmationService.confirm({
            key: 'TemplateMgrDeleteDialog',
            message: msg,
            accept: async () => {

                try {
                    const deleteResponse = await this.deleteTemplateManagerConfig(this.documentTypeId);

                    if (deleteResponse.statusCode === 200) {
                        this.templateManager = new DocumentTypeTemplateManager();
                        this.alertService.showMessage('Template manager configuration deleted', null, MessageSeverity.success);
                    } else {
                        this.alertService.showMessage(`Failed to delete template manager configuration`, 'Unknown error ocurred during the deletion of template manager configuration.', MessageSeverity.error);
                    }

                } catch (error) {
                    this.alertService.showMessage(`Failed to delete template manager configuration`, error.error.Message, MessageSeverity.error);
                }
            },
            reject: () => {
                return;
            }
        });
    }

    clearTemplateManager() {
        this.templateManager = new DocumentTypeTemplateManager();
    }

    private async getTemplateManagerConfig(documentTypeId: number): Promise<DocumentTypeTemplateManager> {
        const request = new GetTemplateManagerRequest(documentTypeId);
        let response = await this.actionService.invoke(this.ActionType, "template-manager-get", request) as GetTemplateManagerResponse;
        return response.templateManager ?? new DocumentTypeTemplateManager();
    }

    private async saveTemplateManagerConfig(documentTypeId: number, templateMgrConfig: DocumentTypeTemplateManager) {
        const request = new SaveTemplateManagerRequest(documentTypeId, templateMgrConfig);
        let response = await this.actionService.invoke(this.ActionType, "template-manager-save", request) as SaveTemplateManagerResponse;
        return response;
    }

    private async deleteTemplateManagerConfig(documentTypeId: number) {
        const request = new DeleteTemplateManagerRequest(documentTypeId);
        let response = await this.actionService.invoke(this.ActionType, "template-manager-delete", request) as DeleteTemplateManagerResponse;
        return response;
    }

    private setInitialTemplateManager() {
        this.initialTemplateMgrConfig = JSON.parse(JSON.stringify(this.templateManager));
    }
}
